FactureValidator.$inject = ['validator'];

export default function FactureValidator(validator) {
    const instance = new validator();

    return instance;
}
